import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=1abdebe6&scoped=true"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdebe6",
  null
  
)

export default component.exports